<div class="grid">
  <div class="col-12">
    <div class="recuadro-widget" style="width: 100%">
      <span class="recuadro-widget-icon bg-green">
              <img src="../../../assets/icons/icono_alcancia_ahorro.svg" alt="alerta" width="90" height="100"
              />
      </span>

      <div class="recuadro-widget-content">
        <span class="recuadro-widget-number">{{contador}}</span>
        <span class="recuadro-widget-text">{{'WIDGETS.LBL_WIDGETSOLICITUDAHPE' | translate }}</span>
        <div style="display: flex;">
          <button style="width: 190%; font-size: 12px;" icon="fa fa-arrow-up" class="p-button p-widget p-state-default p-corner-all p-button-text-only text-center"  label="{{ 'BTN_ACTUALIZAR' | translate}}"
                  type="button" (click)="enviarActualizar()"
                  pButton ></button>
          <button style="width: 100%; margin-left: 10px; font-size: 12px; background-color: #F04505;" class="p-button p-widget p-state-default p-corner-all p-button-text-only excepcion-button" icon="fa fa-plus" label="{{'WIDGETS.BTN_VERMAS' | translate }}"
                  type="button"
                  pButton (click)="visualizarIntegracionesFallidas()"></button>
          <div class="col-12 text-center" *ngIf="loading">
            <i class="fa fa-refresh fa-spin"></i>  <span><strong>{{'LBL_PROCESANDO' | translate }}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="{{ 'WIDGETMODAL.LBL_TITULOMODALSOLICITUDAHORRO' | translate }}" [(visible)]="showModalSolicitudes"
          *ngIf="showModalSolicitudes"
          [positionTop]="60" [contentStyle]="{'width':'1200px', 'overflow-y': 'auto'}" responsive="true" modal="true">
  <div class="grid">
    <div class="col-12">
      <button class="p-button p-widget p-state-default p-corner-all p-button-text-only excepcion-button" icon="fa fa-refresh" label="{{'WIDGETMODAL.BTN_ACTUALIZARTODOS' | translate }}"
              type="button" (click)="enviarActualizarTodo()" *ngIf="listSolicitudes.length>0"
              pButton></button>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 container-integraciones">
      <p-table  [columns]="columnas" [loading]="loadingTable"
                [totalRecords]="numeroRegistros"
                [value]="listSolicitudes"
                [paginator]="true" [rows]="10" [responsive]="true" paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">{{row.idSolicitudInterno}}</td>
            <td class="text-center">{{row.fechaSolicitud | date: 'dd/MM/yyyy' }}</td>
            <td class="text-center">{{row.codigoTipoDocumento | tipoDocumento}}</td>
            <td class="text-center">{{row.numeroDocumento ? (row.numeroDocumento | miles) : ''}}</td>
            <td class="text-center">{{row.nombreEstado}}</td>
            <td class="text-center">
              <button type="button" class="p-button btn" icon="fa fa-refresh" data-toggle="tooltip"
                      title="{{'WIDGETMODAL.BTN_ACTUALIZARESTADOS' | translate}}"
                      pButton (click)="modalConfirmacion(row)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>

<p-dialog [draggable]="false"
            [resizable]="false"
            [closable]="false"
            [responsive]="true"
            [closeOnEscape]="false" [positionTop]="60"
            [(visible)]="modalVerificacion.verificando" *ngIf="modalVerificacion.verificando"
            [contentStyle]="{'width':'600px'}"
            header="{{ 'WIDGETMODAL.LBL_TITULOMODALCUENTAAHORRO' | translate }}"
            [modal]="true">
  <!-- Vista para mostrar la verificacion del archivo -->
  <div *ngIf="modalVerificacion.estActual === 'INIT'" class="col-12 text-center">
    <div class="col-12 text-center">
      <img src="assets/images/preaprobados/loading.gif" alt=""/>
    </div>
    <div class="col-12 text-center">
      <span>{{ 'WIDGETMODAL.LBL_VERIFICACIONENCURSO' | translate }}</span>
    </div>
    <div class="col-12 text-center">
      <span style="color: #009638">{{excelAvance.avance ? utilitiesService.obtenerPlazoCorrecto(excelAvance.avance* 100) : 0}}% </span>
    </div>
  </div>
  <!-- Vista para mostrar errores -->
  <div *ngIf="modalVerificacion.estActual === 'FINVER'" class="col-12">
    <div class="col-12 text-center">
      <i class="fa fa-check-circle" style="color:#009638;  font-size: 20px; margin-right: 8px;"></i>
      <span>{{ 'WIDGETMODAL.LBL_SOLICITUDESESTADOSEXITOSO' | translate }} ({{modalVerificacion.exitoso}})</span>
    </div>
    <div class="col-12 text-center">
      <i class="fa fa-times-circle-o" style="color:red;  font-size: 20px; margin-right: 8px;"></i>
      <span>{{ 'WIDGETMODAL.LBL_SOLICITUDESESTADOSFALLIDO' | translate }} ({{excelAvance.errores.length}})</span>
    </div>
  </div>
  <div *ngIf="modalVerificacion.estActual === 'FINVER' && !modalVerificacion.error" class="col-12">
    <div class="col-12 text-center">
      <span>{{ 'MODALCARGAARCHIVO.LBL_ERRORESENCONTRADOS' | translate }}</span>
    </div>
    <div class="col-12" style="max-height: 150px; overflow:auto;">
      <ol>
        <li *ngFor="let error of excelAvance.errores">
          <span class="badge">{{error}}</span>
        </li>
      </ol>
    </div>
  </div>
  <div class="col-12 form-footer-buttons">
    <div class="form-group col-12">
      <button *ngIf="modalVerificacion.estActual !== 'INIT'" label="{{ 'MODALCARGAARCHIVO.BTN_CERRAR' | translate }}" pButton
              class="p-button-secondary btns-acciones" (click)="cerrarVerificacion()"></button>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
<p-confirmDialog #cd key="flujo-venta-proceso">
  <p-footer>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_ACEPTAR' | translate }}" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
<p-confirmDialog #cd3 key="cambio-estado">
  <p-footer>
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd3.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd3.accept()"></button>
  </p-footer>
</p-confirmDialog>

